import React from 'react';
import { Grid } from '@mui/material';

import { Typography, TextField, ProductGroupSelectField } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

export const BuyAndGetConfiguration: React.FC = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <Typography variant='subtitle1' gutterBottom>
          Buy
        </Typography>
        <TextField
          name='buyAndGet.purchaseThreshold'
          label='Items'
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography variant='subtitle1' gutterBottom>
          Get free
        </Typography>
        <TextField
          name='buyAndGet.discountThreshold'
          label='Items'
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='subtitle1' paragraph>
          On the following product group(s):
        </Typography>
        <ProductGroupSelectField
          inputProps={{
            margin: 'none',
          }}
          name='buyAndGet.eligibleProductGroups'
          label='Product groups'
        />
      </Grid>
    </Grid>
  );
};
